export function objectKeys(object) {
    let keys = [];

    for (let key in object) {
        if (key === 'undefined') {
            throw new Error('objectKeys found undefined key !!!');
        }

        keys.push(key);
    }

    return keys;
}

export function hasUndefinedKey(object) {
    for (let key in object) {
        if (key === 'undefined') {
            return true;
        }
    }

    return false;
}

export function objectKeyCount(object) {
    let keyCount = 0;

    for (let key in object) {
        if (key === 'undefined') {
            throw new Error('objectKeyCount found undefined key !!!');
        }

        keyCount++;
    }

    return keyCount;
}

export function tryParseInt(value, base = 10) {
    let parsedValue = parseInt(value, base);

    if (!isNaN(parsedValue)) {
        return parsedValue; // We parsed it alright, let's return it
    }

    return value; // Just return the original value if the parsing failed
}

export function tryParseFloat(value) {
    let parsedValue = parseFloat(value);

    if (!isNaN(parsedValue)) {
        return parsedValue; // We parsed it alright, let's return it
    }

    return value; // Just return the original value if the parsing failed
}

export function smartCompare(value1, value2) {
    let typeValue1 = typeof(value1);
    let typeValue2 = typeof(value2);

    // Both values are the same type, so we can simply strictly compare them
    if (typeValue1 === typeValue2) {
        return value1 === value2;
    }

    return value1.toString() === value2.toString();
}